<script lang="ts">
  import { Button, FormGroup } from "carbon-components-svelte";
  import Slider from "./Slider.svelte";

  export let label: string;
  export let spacing: number[] = [];
  export let min: number = 0;
  export let max: number = 0;
  export let step: number = 1;

  let master_control_value: number;

  let SubControlsVisible: boolean = false;

  let getSideName = (sideNumber: any) => {
    switch (sideNumber) {
      case 0:
        return "Top";
      case 1:
        return "Right";
      case 2:
        return "Bottom";
      case 3:
        return "Left";
      default:
        break;
    }
  };

  let load = () => {
    // there should be values for 4 sides, use 0 for missing ones
    for (let i = 0; i < 4; i++) !spacing[i] && (spacing[i] = 0);
  };

  let update_master = (sideNumber, value) => {
    spacing[sideNumber] = value;
    master_control_value =
      spacing.reduce((total, item) => total + item, 0) / spacing.length;
  };

  let update_individual_values = () => {
    for (let i = 0; i < spacing.length; i++) {
      spacing[i] = master_control_value;
    }
  };

  load();
</script>

<FormGroup noMargin>
  <div class="stack pane">
    {#if !SubControlsVisible}
      <Slider
        labelText="{label} (all sides)"
        {min}
        {max}
        {step}
        bind:value={master_control_value}
        on:change={update_individual_values}
      />
    {/if}

    <Button
      kind="tertiary"
      on:click={() => {
        SubControlsVisible = !SubControlsVisible;
      }}
    >
      {#if !SubControlsVisible}
        Change {label} for each side
      {:else}
        Change {label} for all sides
      {/if}
    </Button>

    {#if SubControlsVisible}
      {#each spacing as side, count}
        <Slider
          labelText="{label} ({getSideName(count)})"
          {min}
          {max}
          {step}
          value={side}
          on:change={(e) => {
            update_master(count, e.detail);
          }}
        />
      {/each}
    {/if}
  </div>
</FormGroup>
